import React, {
  useEffect,
  useState,
} from "react";

import {
  fetchKpiSummary,
  formatApiError,
} from "../services/api";

function KPICards({
  handleKpiClick,
  products = [],
}) {

  // =====================================================
  // STATES
  // =====================================================

  const [kpiData, setKpiData] =
    useState(null);

  const [loading, setLoading] =
    useState(true);

  const [error, setError] =
    useState("");

  // =====================================================
  // LOAD KPI DATA
  // =====================================================

  useEffect(() => {

    loadKpiData();

  }, []);

  const loadKpiData =
    async () => {

      try {

        setLoading(true);

        const response =
          await fetchKpiSummary();

        console.log(
          "KPI DATA:",
          response.data
        );

        setKpiData(
          response.data || {}
        );

      } catch (err) {

        console.error(
          "KPI API ERROR:",
          err
        );

        setError(
          formatApiError(err)
        );

      } finally {

        setLoading(false);
      }
    };

  // =====================================================
  // LOADING
  // =====================================================

  if (loading) {

    return (

      <div className="kpi-loading">

        Loading KPI Dashboard...

      </div>
    );
  }

  // =====================================================
  // ERROR
  // =====================================================

  if (error) {

    return (

      <div className="kpi-error">

        {error}

      </div>
    );
  }

  // =====================================================
  // SAFETY
  // =====================================================

  if (!kpiData) {

    return null;
  }

  // =====================================================
  // DATA
  // =====================================================

  const totalProducts =
    kpiData.totalProducts ??
    kpiData.total_products ??
    0;

  const f2bCheapest =
    kpiData.f2bCheapest ??
    kpiData.f2b_cheapest ??
    0;

  const expensiveProducts =
    kpiData.f2bExpensive ??
    kpiData.f2b_expensive ??
    0;

  const cheapestProducts =
    kpiData.cheapestProducts ??
    kpiData.f2b_cheapest ??
    0;

  const allProducts =
    kpiData.allProducts ??
    [];

  // =====================================================
  // RENDER
  // =====================================================

  return (

    <div className="kpi-container">

      {/* ===============================================
          TITLE
      =============================================== */}

      <h2 className="kpi-title">

        KPI Summary Dashboard

      </h2>

      {/* ===============================================
          GRID
      =============================================== */}

      <div className="kpi-grid">

        {/* ===========================================
            TOTAL PRODUCTS
        =========================================== */}

        <div
          className="kpi-card"
          onClick={() =>
            handleKpiClick(
              "Total Products",
              products
            )
          }
        >

          <div className="kpi-icon">

            📦

          </div>

          <h3>
            Total Products
          </h3>

          <p>
            {totalProducts}
          </p>

        </div>

        {/* ===========================================
            F2B CHEAPEST
        =========================================== */}

        <div
          className="kpi-card success-card"
          onClick={() =>
            handleKpiClick(
              "F2B Cheapest Products",
              products.filter((item) => {
                const cheapest =
                  (item.cheapest_platform || "").toLowerCase();
                return (
                  cheapest.includes("farm2bag") ||
                  cheapest.includes("f2b")
                );
              })
            )
          }
        >

          <div className="kpi-icon">

            🟢

          </div>

          <h3>
            F2B Cheapest
          </h3>

          <p>
            {f2bCheapest}
          </p>

        </div>

        {/* ===========================================
            AVG PRICE DIFFERENCE
        =========================================== */}

        {/* ===========================================
            F2B EXPENSIVE
        =========================================== */}

        <div
          className="kpi-card danger-card"
          onClick={() =>
            handleKpiClick(
              "F2B Expensive Products",
              products.filter((item) => {
                const cheapest =
                  (item.cheapest_platform || "").toLowerCase();
                return (
                  !cheapest.includes("farm2bag") &&
                  !cheapest.includes("f2b")
                );
              })
            )
          }
        >

          <div className="kpi-icon">

            🔴

          </div>

          <h3>
            F2B Expensive Products
          </h3>

          <p>
            {expensiveProducts}
          </p>

        </div>

      </div>

    </div>
  );
}

export default KPICards;